<template>
  <div :id="chartKey" style="width: 100%" :style="{ height: height }"></div>
</template>

<script>
import CanvasJS from './canvasjs.min.js'

export default {
  name: 'Canvasjs',
  props: {
    chartOptions: {
      require: true,
      type: Object
    },
    height: {
      require: false,
      type: String
    },
    chartKey: {
      require: true,
      type: String
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.chart = new CanvasJS.Chart(this.chartKey, this.chartOptions)
    this.chart.render()
  },
  destroyed() {
    this.chart.destroy()
  }
}
</script>

<style></style>
